export default "__VITE_ASSET__D_5Me2AZ__"